import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'

import Overview from './Overview'
import i18n from './../i18n'
import { config } from '../../util'

Vue.config.productionTip = false

Vue.use(BootstrapVue)

export default selector => {
  const el = typeof selector === 'string' ? document.querySelector(selector) : selector

  let data = { ...el.dataset }
  let warehouses = []
  const warehouseId = el.dataset.warehouseId || null
  const warehouseMultiple = el.dataset.warehouseMultiple !== undefined
  const hideWarehouseFilter = el.dataset.hideWarehouseFilter !== undefined
  const currentUrl = el.dataset.currentUrl || null
  let activities = []
  const activityId = el.dataset.activityId || null
  const hideActivityFilter = el.dataset.hideActivityFilter !== undefined
  const activityMultiple = el.dataset.activityMultiple !== undefined
  const maxPerDay = Number(el.dataset.maxPerDay) || null

  try {
    data = { ...el.dataset }
    warehouses = data.warehouses ? JSON.parse(data.warehouses) : []
    activities = data.activities ? JSON.parse(data.activities) : []
  } catch (error) {
    console.error('Error parsing data to load timetable!', error) // eslint-disable-line no-console
  }

  const locale = data.locale || 'nl-NL'
  config.locale = locale
  i18n(locale)

  new Vue({
    data: {
      locale,
      ...data,
      csrfToken: data.csrfToken,
      warehouses,
      warehouseMultiple,
      warehouseId,
      hideWarehouseFilter,
      currentUrl,
      activities,
      activityId,
      activityMultiple,
      hideActivityFilter,
      maxPerDay
    },
    render: h => h(Overview)
  }).$mount(el)
}
